import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { AAM, GameState } from '../../interfaces/game.interface';
import { DataService } from '../../services/data.service';
import { filter, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { resourceLimits } from 'worker_threads';

@Component({
  selector: 'app-aam-page',
  templateUrl: './aam-page.component.html',
  styleUrls: ['./aam-page.component.scss']
})
export class AamPageComponent implements OnInit {
  @Output() closeClick = new EventEmitter<void>();
  game_state: GameState | null = null;
  aam$: Observable<AAM>;

  constructor(private dataService: DataService) {}

  ngOnInit(): void {
    this.aam$ = this.dataService.gameState$.pipe(
      filter((state): state is GameState => state !== null), // Type guard
      map(state => state.aam)
    )
  }
  
  assign(x: number) {
    const currentState = this.dataService.getGameStateSnapshot();
    if (!currentState) return;

    const updatedState = {
      ...currentState,
      aam: {
        aam_incentives: x,
        is_aam_selected: false
      }
    }
  
    this.dataService.setState(updatedState);
  }

  confirm() {
    const currentState = this.dataService.getGameStateSnapshot();
    if (!currentState) return;

    const updatedState = {
      ...currentState,
      aam: {
        ...currentState.aam,
        is_aam_selected: true
      },
      resource_limits: {
        ...currentState.resource_limits,
        q3: {  // increase incentives
          ...currentState.resource_limits.q3,
          incentives: currentState.resource_limits.q3.incentives + currentState.aam.aam_incentives
        }
      }
    }
  
    this.dataService.setState(updatedState);
  }

  onCloseClick(): void {
    this.closeClick.emit();
  }
}
